"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reflux = _interopRequireDefault(require("reflux"));

var _CourseLoader = _interopRequireDefault(require("../../../helpers/CourseLoader"));

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _strings = require("../../../../config/strings");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _ExternalWebsite = _interopRequireDefault(require("./ExternalWebsite.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _KeyboardHelper = require("../../../helpers/KeyboardHelper");

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var COMMANDS = {
  SET_TITLE: 'set_title',
  LOAD_ERROR: 'load_error',
  GET_AUTH_TOKEN: 'getAuthToken'
};
var COMMANDS_TO_IFRAME = {
  REQUESTED_VALUE: 'requested_value',
  AUTH_TOKEN: 'authToken'
};
var URL_PARAM_START = '${';
var URL_PARAM_END = '}';
var SUPPORTED_PARAMS = {
  ACTIVATED_FEATURES: 'activated_features',
  APP_HOST: 'app_host',
  QUIZZER_HOST: 'quizzer_host',
  APP_NAME: 'app_name',
  APP_PASSWORD: 'app_password',
  APP_USERNAME: 'app_username',
  APP_VERSION: 'app_version',
  CURRENT_THEME: 'current_theme',
  DEVICE_UUID: 'deviceuuid',
  FEATURE_USERID: 'userid',
  FEATURE_NICKNAME: 'nickname',
  FEATURE_REQUEST_CODE: 'request_code',
  LANGUAGE: 'lang',
  HIDE_FEEDBACK: 'hide_feedback'
};
var SECURED_PARAMS = [SUPPORTED_PARAMS.ACTIVATED_FEATURES, SUPPORTED_PARAMS.APP_HOST, SUPPORTED_PARAMS.APP_NAME, SUPPORTED_PARAMS.APP_VERSION, SUPPORTED_PARAMS.APP_PASSWORD, SUPPORTED_PARAMS.APP_USERNAME, SUPPORTED_PARAMS.DEVICE_UUID, SUPPORTED_PARAMS.FEATURE_USERID, SUPPORTED_PARAMS.FEATURE_NICKNAME, SUPPORTED_PARAMS.FEATURE_REQUEST_CODE];
var MAX_LOAD_DURATION = 10000; // in ms

var ExternalWebsite = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(ExternalWebsite, _StoreComponent);

  var _super = _createSuper(ExternalWebsite);

  function ExternalWebsite(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, ExternalWebsite);
    _this = _super.call(this, props); // this is just a placeholder for a better coding experience

    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLoaded", function () {
      console.log('iframe loaded (External Website)');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLoadError", function (reason) {
      if (_this.errorTimer) {
        _this.errorTimer.invalidate();

        _this.errorTimer = null;
      }

      _this.setState({
        initialized: false,
        loaded: false
      });

      console.log('iframerror', reason);
      var buttonOk = {
        label: (0, _strings.getString)('OK'),
        callback: function callback() {
          _NavigationManager["default"].goBack();
        }
      };
      var buttonTryAgain = {
        label: (0, _strings.getString)('TRY_AGAIN'),
        callback: function () {
          var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!_DeviceInfoHelper["default"].isOnline()) {
                      _context.next = 2;
                      break;
                    }

                    return _context.abrupt("return", _this.init(_this.props));

                  case 2:
                    console.log('FIRE 1');

                    _this.onLoadError();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function callback() {
            return _callback.apply(this, arguments);
          }

          return callback;
        }()
      };

      if (reason) {
        (0, _AlertHelper.showAlertWithOptions)({
          message: (0, _strings.getString)('ERROR_LOADING_CONTENT_WITH_REASON', [reason]),
          buttons: [buttonTryAgain, buttonOk],
          size: 'large',
          showCloseButton: false
        }); // showWideAlert(getString('ERROR_LOADING_CONTENT_WITH_REASON', [reason]), null, false, true, [buttonTryAgain, buttonOk])
      } else {
        (0, _AlertHelper.showAlertWithOptions)({
          message: (0, _strings.getString)('ERROR_LOADING_CONTENT'),
          buttons: [buttonTryAgain, buttonOk],
          size: 'large',
          showCloseButton: false
        }); // showWideAlert(getString('ERROR_LOADING_CONTENT'), null, false, true, [buttonTryAgain, buttonOk])
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onReceiveMessage", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(evt) {
        var data, title, consumed, scopes, callbackId, allowed, authToken, keyboardEvent;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // any message (even empty) means that the iFrame is loaded
                if (_this.errorTimer) {
                  _this.errorTimer.invalidate();

                  _this.errorTimer = null;
                }

                _this.shouldStartErrorTimer = false;

                if (_this.state.loaded) {
                  _this.setState({
                    loaded: false
                  });
                }

                console.log('got message from iframe (event):', evt);

                if (!(!evt.data || evt.data.length == 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                if (!(evt.data === 'scrollToTop')) {
                  _context2.next = 12;
                  break;
                }

                if (_DeviceInfoHelper["default"].isiOS()) {
                  window.scrollTo(0, 0);
                }

                return _context2.abrupt("return");

              case 12:
                _context2.prev = 12;
                data = JSON.parse(evt.data);
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](12);
                console.log('data not parseable', evt.data);

                _this.setState({
                  loaded: true
                });

                return _context2.abrupt("return");

              case 21:
                console.log('got message from iframe:', data);
                _context2.t1 = data.command;
                _context2.next = _context2.t1 === 'alive' ? 25 : _context2.t1 === 'setTitle' ? 27 : _context2.t1 === 'backCallback' ? 30 : _context2.t1 === 'getAuthToken' ? 34 : _context2.t1 === 'hideKeyboard' ? 54 : _context2.t1 === 'openInSystemBrowser' ? 57 : _context2.t1 === 'openPDF' ? 59 : _context2.t1 === 'downloadFile' ? 61 : _context2.t1 === 'deleteFile' ? 63 : _context2.t1 === 'scrollToTop' ? 65 : 67;
                break;

              case 25:
                _this.setIframeLoaded();

                return _context2.abrupt("break", 67);

              case 27:
                title = data.value;

                if (title) {
                  _this.props.setTitle(title);
                }

                return _context2.abrupt("break", 67);

              case 30:
                clearTimeout(_this.backTimer);
                consumed = data.consumed;

                if (!consumed) {
                  _this.callDefaultBack();
                }

                return _context2.abrupt("break", 67);

              case 34:
                scopes = data.scopes;
                callbackId = data.callbackId; // check scopes if in scopes of drupal

                allowed = _this.checkScopes(scopes);

                if (allowed) {
                  _context2.next = 41;
                  break;
                }

                _this.sendCommandToIframe({
                  command: 'authTokenFailed',
                  error: 'Scopes not allowed',
                  callbackId: callbackId
                });

                _context2.next = 53;
                break;

              case 41:
                if (!scopes) {
                  _context2.next = 53;
                  break;
                }

                _context2.prev = 42;
                _context2.next = 45;
                return _RegisterInstance["default"].getAccessToken(scopes);

              case 45:
                authToken = _context2.sent;

                if (authToken) {
                  _this.sendCommandToIframe({
                    command: 'authToken',
                    authToken: authToken,
                    callbackId: callbackId
                  });
                } else {
                  _this.sendCommandToIframe({
                    command: 'authTokenFailed',
                    error: 'No access',
                    callbackId: callbackId
                  });
                }

                _context2.next = 53;
                break;

              case 49:
                _context2.prev = 49;
                _context2.t2 = _context2["catch"](42);

                _this.sendCommandToIframe({
                  command: 'authTokenFailed',
                  error: {
                    message: _context2.t2.message,
                    code: _context2.t2.code
                  },
                  callbackId: callbackId
                });

                _this.setState({
                  error: _context2.t2
                });

              case 53:
                return _context2.abrupt("break", 67);

              case 54:
                (0, _KeyboardHelper.hideKeyboard)(true);

                if (_DeviceInfoHelper["default"].isAndroid()) {
                  keyboardEvent = new window.CustomEvent('hideKeyboard');
                  document.dispatchEvent(keyboardEvent);
                }

                return _context2.abrupt("break", 67);

              case 57:
                window.open(data.url, '_system');
                return _context2.abrupt("break", 67);

              case 59:
                _this.openPDF(data.filename);

                return _context2.abrupt("break", 67);

              case 61:
                _this.downloadFile(data.callbackId, data.url, data.localFilename, data.reload);

                return _context2.abrupt("break", 67);

              case 63:
                console.error('The function deleteFile is not yet implemented');
                return _context2.abrupt("break", 67);

              case 65:
                if (_DeviceInfoHelper["default"].isiOS()) {
                  window.scrollTo(0, 0);
                }

                return _context2.abrupt("break", 67);

              case 67:
                _context2.next = 73;
                break;

              case 69:
                _context2.prev = 69;
                _context2.t3 = _context2["catch"](0);
                // just go on
                console.error(_context2.t3);

                _this.setState({
                  error: _context2.t3
                });

              case 73:
                // any message received means the site is loaded
                _this.setState({
                  loaded: true
                });

              case 74:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 69], [12, 16], [42, 49]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkScopes", function (scopes) {
      if (typeof scopes === 'undefined' || !scopes || scopes.length === 0) {
        return false;
      }

      return true;
    });
    _this.state = {
      url: null,
      initialized: false,
      loaded: false
    };
    _this.id = _StringHelper["default"].createUuid();
    _this.shouldStartErrorTimer = true;
    _this.appInfo = null;
    _this.users = {};
    _this.errorTimer = null;
    _this.initInProgressOrDone = false;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(ExternalWebsite.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme']
    }]);

    if (!props.hidden) {
      _this.init(props);
    }

    return _this;
  }

  (0, _createClass2["default"])(ExternalWebsite, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_DeviceInfoHelper["default"].isOnline()) {
        console.log('FIRE 2');
        this.onLoadError();
      }

      (0, _KeyboardHelper.setKeyboardMightBeOpen)();

      if (!this.props.hidden) {
        this.init(this.props);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!this.props.hidden && (prevProps.hidden || this.props.params && this.props.params.id !== prevProps.params.id || this.props.url !== prevProps.url)) {
        this.initInProgressOrDone = false;
        this.init(this.props);
      }
    }
    /*
    componentWillReceiveProps (nextProps) {
      if ((this.props.hidden && !nextProps.hidden) || ((nextProps.params && nextProps.params.id !== this.props.params.id) || nextProps.url !== this.props.url)) {
        this.init(nextProps)
      }
      if (nextProps.hidden && !this.props.hidden) {
        console.log('INVALIDATE timer 2')
        if (this.errorTimer) {
          console.log('INVALIDATE timer 2 (really)', this.errorTimer.timeoutId)
          this.errorTimer.invalidate()
        }
      }
    }
    */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      console.log('INVALIDATE timer');

      if (this.errorTimer) {
        console.log('INVALIDATE timer (really)', this.errorTimer.timeoutId);
        this.errorTimer.invalidate();
      }

      window.removeEventListener('message', this.onReceiveMessage);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ExternalWebsite.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getDataStorePathForKey",
    value: function getDataStorePathForKey(key) {
      if (key.indexOf('.') > 0) {
        return key;
      }

      return "".concat(_DataStore.DATA_STORE_PATHS.IFRAME_DATA, ".").concat(key);
    }
  }, {
    key: "setIframeLoaded",
    value: function () {
      var _setIframeLoaded = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var objToSend;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isIframeWithMessagingLoaded) {
                  this.isIframeWithMessagingLoaded = true; // send command to iframe to let the kesi-iframe script know that it lives in an iframe

                  objToSend = {
                    command: 'frameLoaded',
                    os: _DeviceInfoHelper["default"].getOS()
                  };
                  this.sendCommandToIframe(objToSend);
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setIframeLoaded() {
        return _setIframeLoaded.apply(this, arguments);
      }

      return setIframeLoaded;
    }()
  }, {
    key: "sendCommandToIframe",
    value: function sendCommandToIframe(command) {
      var iframe = document.getElementById(this.id);

      if (iframe) {
        iframe.contentWindow.postMessage(command, '*');
      }
    }
  }, {
    key: "getAppInfo",
    value: function () {
      var _getAppInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var appName, version;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!this.appInfo) {
                  appName = window.BuildInfo ? window.BuildInfo.displayName : null;
                  version = window.BuildInfo ? window.BuildInfo.version : null;
                  this.appInfo = {
                    host: 'https://ems3.equeo.de/ems-webapp',
                    quizzerHost: 'https://equeo-quizzer-dev.equeo.de',
                    appName: appName,
                    default_password: _config["default"].defaultPassword,
                    default_user: _config["default"].defaultUser,
                    version: version
                  };
                }

                return _context4.abrupt("return", _promise["default"].resolve(this.appInfo));

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", _promise["default"].reject(_context4.t0));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function getAppInfo() {
        return _getAppInfo.apply(this, arguments);
      }

      return getAppInfo;
    }()
  }, {
    key: "getUser",
    value: function () {
      var _getUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(featureName) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (!this.users[featureName]) {
                  this.users[featureName] = null; // await getUser(featureName);
                }

                return _context5.abrupt("return", _promise["default"].resolve(this.users[featureName]));

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function getUser(_x2) {
        return _getUser.apply(this, arguments);
      }

      return getUser;
    }()
  }, {
    key: "getStyle",
    value: function getStyle() {
      if (!this.props.hidden && (this.state.loaded || !this.props.externalWebsiteSendsMessages && this.props.route && !this.props.route.externalWebsiteSendsMessages)) {
        return {};
      }

      return {
        opacity: 0
      };
    }
  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(props) {
        var state, course;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this.initInProgressOrDone) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                this.setState({
                  error: null
                });
                this.initInProgressOrDone = true;
                this.appInfo = null;
                this.users = {};

                if (this.errorTimer) {
                  this.errorTimer.invalidate();
                  this.errorTimer = null;
                }

                window.removeEventListener('message', this.onReceiveMessage);
                state = {
                  initialized: true
                };

                if (!(props.params && props.params.id)) {
                  _context6.next = 22;
                  break;
                }

                _context6.next = 12;
                return _CourseLoader["default"].getCourse(props.params.id);

              case 12:
                course = _context6.sent;
                console.log('external website', course, props.params.id);

                if (!course.keywords) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 17;
                return this.replacePlaceholderInUrl(course.keywords);

              case 17:
                state.url = _context6.sent;
                console.log("loading url in iframe: ".concat(state.url));

                if (course.title) {
                  this.props.setTitle(course.title);
                }

              case 20:
                _context6.next = 26;
                break;

              case 22:
                if (!props.url) {
                  _context6.next = 26;
                  break;
                }

                _context6.next = 25;
                return this.replacePlaceholderInUrl(props.url);

              case 25:
                state.url = _context6.sent;

              case 26:
                this.setState(state);
                _context6.next = 29;
                return (0, _TimeoutHelper.timeout)();

              case 29:
                if (this.props.externalWebsiteSendsMessages || this.props.route && this.props.route.externalWebsiteSendsMessages) {
                  window.addEventListener('message', this.onReceiveMessage);
                  this.startLoadTimer();
                }

              case 30:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init(_x3) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "parseParametersInUrl",
    value: function parseParametersInUrl(url) {
      var collectedParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var startIndex = url.indexOf(URL_PARAM_START, index);

      if (startIndex < 0) {
        return collectedParams;
      }

      var endIndex = url.indexOf(URL_PARAM_END, startIndex + URL_PARAM_START.length);

      if (endIndex < 0) {
        (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
          message: 'Missing closing curly brace for url parameter'
        }); // showAlertInDebugMode('Missing closing curly brace for url parameter')

        return collectedParams;
      }

      var paramInUrl = url.substring(startIndex + URL_PARAM_START.length, endIndex);
      var command = paramInUrl;
      var args = [];
      var argsStartIndex = paramInUrl.indexOf('(');

      if (argsStartIndex >= 0) {
        command = paramInUrl.substring(0, argsStartIndex);
        var argsEndIndex = paramInUrl.indexOf(')', argsStartIndex + 1);
        args = paramInUrl.substring(argsStartIndex + 1, argsEndIndex).split(',');
        args = args.map(function (arg) {
          return arg.trim();
        });
      }

      var parsedParam = {
        COMMAND: command,
        ARGS: args,
        START: startIndex,
        END: endIndex
      };
      return this.parseParametersInUrl(url, collectedParams.concat(parsedParam), endIndex + 1);
    }
  }, {
    key: "replacePlaceholderInUrl",
    value: function () {
      var _replacePlaceholderInUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(url) {
        var _this2 = this;

        var params, isSecuredConnection, parametrizedUrl, promises, results;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = this.parseParametersInUrl(url);
                isSecuredConnection = url.startsWith('https://');
                parametrizedUrl = url;
                console.log({
                  params: params
                });
                promises = params.map( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(param) {
                    var returnValue, command, appInfo, _appInfo, _appInfo2, _appInfo3, _appInfo4, _appInfo5, _appInfo6, feature, _feature, _feature2;

                    return _regenerator["default"].wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            returnValue = {
                              VALUE: 'null',
                              START: param.START,
                              END: param.END
                            };
                            command = param.COMMAND;

                            if (!((0, _values["default"])(SUPPORTED_PARAMS).indexOf(command) < 0)) {
                              _context7.next = 6;
                              break;
                            }

                            (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                              message: "Unsupported parameter in iframe url: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "]")
                            }); // showAlertInDebugMode(`Unsupported parameter in iframe url: ${command}${JSON.stringify(param.ARGS)}]`)

                            _context7.next = 67;
                            break;

                          case 6:
                            if (!(!isSecuredConnection && SECURED_PARAMS.indexOf(command >= 0))) {
                              _context7.next = 10;
                              break;
                            }

                            (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                              message: 'Sending secret parameters over an unsecured connection (not being https://) is not supported',
                              title: 'Warning'
                            }); // showAlertInDebugMode('Sending secret parameters over an unsecured connection (not being https://) is not supported', 'Warning')

                            _context7.next = 66;
                            break;

                          case 10:
                            if (!(command === SUPPORTED_PARAMS.ACTIVATED_FEATURES)) {
                              _context7.next = 17;
                              break;
                            }

                            _context7.next = 13;
                            return _this2.getAppInfo();

                          case 13:
                            appInfo = _context7.sent;
                            returnValue.VALUE = (0, _stringify["default"])(appInfo.features);
                            _context7.next = 66;
                            break;

                          case 17:
                            if (!(command === SUPPORTED_PARAMS.APP_HOST)) {
                              _context7.next = 24;
                              break;
                            }

                            _context7.next = 20;
                            return _this2.getAppInfo();

                          case 20:
                            _appInfo = _context7.sent;
                            returnValue.VALUE = _appInfo.host;
                            _context7.next = 66;
                            break;

                          case 24:
                            if (!(command === SUPPORTED_PARAMS.QUIZZER_HOST)) {
                              _context7.next = 31;
                              break;
                            }

                            _context7.next = 27;
                            return _this2.getAppInfo();

                          case 27:
                            _appInfo2 = _context7.sent;
                            returnValue.VALUE = _appInfo2.quizzerHost;
                            _context7.next = 66;
                            break;

                          case 31:
                            if (!(command === SUPPORTED_PARAMS.APP_NAME)) {
                              _context7.next = 38;
                              break;
                            }

                            _context7.next = 34;
                            return _this2.getAppInfo();

                          case 34:
                            _appInfo3 = _context7.sent;
                            returnValue.VALUE = _appInfo3.appName;
                            _context7.next = 66;
                            break;

                          case 38:
                            if (!(command === SUPPORTED_PARAMS.APP_PASSWORD)) {
                              _context7.next = 45;
                              break;
                            }

                            _context7.next = 41;
                            return _this2.getAppInfo();

                          case 41:
                            _appInfo4 = _context7.sent;
                            returnValue.VALUE = _appInfo4.default_password;
                            _context7.next = 66;
                            break;

                          case 45:
                            if (!(command === SUPPORTED_PARAMS.APP_USERNAME)) {
                              _context7.next = 52;
                              break;
                            }

                            _context7.next = 48;
                            return _this2.getAppInfo();

                          case 48:
                            _appInfo5 = _context7.sent;
                            returnValue.VALUE = _appInfo5.default_user;
                            _context7.next = 66;
                            break;

                          case 52:
                            if (!(command === SUPPORTED_PARAMS.APP_VERSION)) {
                              _context7.next = 59;
                              break;
                            }

                            _context7.next = 55;
                            return _this2.getAppInfo();

                          case 55:
                            _appInfo6 = _context7.sent;
                            returnValue.VALUE = _appInfo6.version;
                            _context7.next = 66;
                            break;

                          case 59:
                            if (!(command === SUPPORTED_PARAMS.DEVICE_UUID)) {
                              _context7.next = 65;
                              break;
                            }

                            _context7.next = 62;
                            return _RegisterInstance["default"].getApplicationInstanceId();

                          case 62:
                            returnValue.VALUE = _context7.sent;
                            _context7.next = 66;
                            break;

                          case 65:
                            if (command === SUPPORTED_PARAMS.FEATURE_NICKNAME) {
                              if (param.ARGS.length < 1) {
                                (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                  message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                                }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)
                              } else {
                                try {
                                  feature = _FeatureManager["default"].getFeature(param.ARGS[0]);
                                  returnValue.VALUE = feature ? feature.additionalData.nickname : null;
                                } catch (error) {
                                  (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                    message: "Couldn't retrieve info for iframe param: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (").concat(error, ")")
                                  }); // showAlertInDebugMode(`Couldn't retrieve info for iframe param: ${command}${JSON.stringify(param.ARGS)}] (${error})`)
                                }
                              }
                            } else if (command === SUPPORTED_PARAMS.FEATURE_USERID) {
                              if (param.ARGS.length < 1) {
                                (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                  message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                                }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)
                              } else {
                                try {
                                  _feature = _FeatureManager["default"].getFeature(param.ARGS[0]);
                                  returnValue.VALUE = _feature ? _feature.userId : null;
                                } catch (error) {
                                  (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                    message: "Couldn't retrieve info for iframe param: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (").concat(error, ")")
                                  }); // showAlertInDebugMode(`Couldn't retrieve info for iframe param: ${command}${JSON.stringify(param.ARGS)}] (${error})`)
                                }
                              }
                            } else if (command === SUPPORTED_PARAMS.FEATURE_REQUEST_CODE) {
                              if (param.ARGS.length < 1) {
                                (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                  message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                                }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)
                              } else {
                                try {
                                  _feature2 = _FeatureManager["default"].getFeature(param.ARGS[0]);
                                  returnValue.VALUE = _feature2 ? _feature2.activationCode : null;
                                } catch (error) {
                                  (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                    message: "Couldn't retrieve info for iframe param: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (").concat(error, ")")
                                  }); // showAlertInDebugMode(`Couldn't retrieve info for iframe param: ${command}${JSON.stringify(param.ARGS)}] (${error})`)
                                }
                              }
                            }

                          case 66:
                            // unsecured parameters
                            if (command === SUPPORTED_PARAMS.CURRENT_THEME) {
                              returnValue.VALUE = _this2.state.currentTheme;
                            } else if (command === SUPPORTED_PARAMS.LANGUAGE) {
                              // TODO: implement central store for current language in case we ever implement language switch
                              returnValue.VALUE = _config["default"].supportedLanguages[0];
                            }

                          case 67:
                            return _context7.abrupt("return", _promise["default"].resolve(returnValue));

                          case 68:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _context8.next = 7;
                return _promise["default"].all(promises);

              case 7:
                results = _context8.sent.sort(function (paramValueA, paramValueB) {
                  return paramValueA.START - paramValueB.START;
                }).reverse();
                console.log({
                  results: results
                });
                results.forEach(function (result) {
                  parametrizedUrl = parametrizedUrl.substring(0, result.START) + window.encodeURIComponent(result.VALUE) + parametrizedUrl.substring(result.END + 1);
                });
                return _context8.abrupt("return", _promise["default"].resolve(parametrizedUrl));

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function replacePlaceholderInUrl(_x4) {
        return _replacePlaceholderInUrl.apply(this, arguments);
      }

      return replacePlaceholderInUrl;
    }()
  }, {
    key: "startLoadTimer",
    value: function () {
      var _startLoadTimer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.shouldStartErrorTimer) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                this.errorTimer = new _TimeoutHelper.InvalidatableTimeout(MAX_LOAD_DURATION); // timer is invalidated in onReceiveMessage

                console.log('FIRE 4a (wait)', (0, _now["default"])());
                _context9.prev = 4;
                _context9.next = 7;
                return this.errorTimer.restart();

              case 7:
                console.log('FIRE 4', (0, _now["default"])());
                this.onLoadError();
                _context9.next = 14;
                break;

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](4);
                // timer was invalidated
                console.log('FIRE 4b (invalidated)', (0, _now["default"])());

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[4, 11]]);
      }));

      function startLoadTimer() {
        return _startLoadTimer.apply(this, arguments);
      }

      return startLoadTimer;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.initialized) {
        return null;
      }

      if (this.state.error) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            color: 'red',
            padding: '20px'
          }
        }, this.state.error.message);
      }

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        className: _ExternalWebsite["default"].iframe,
        style: this.getStyle(),
        src: this.state.url,
        onLoad: this.onLoaded,
        id: this.id
      });
    }
  }]);
  return ExternalWebsite;
}(_StoreComponent2["default"]);

ExternalWebsite.propTypes = {
  params: _propTypes["default"].shape({
    id: _propTypes["default"].string
  }),
  route: _propTypes["default"].shape({
    externalWebsiteSendsMessages: _propTypes["default"].bool
  }),
  url: _propTypes["default"].string,
  externalWebsiteSendsMessages: _propTypes["default"].bool,
  setTitle: _propTypes["default"].func,
  hidden: _propTypes["default"].bool
};
var _default = ExternalWebsite;
exports["default"] = _default;